<style src="./ContextMinimumFilter.scss" lang="scss"></style>
<template>
  <section class="context-minimum-filter">
    <div class="rowsection">
      <span class="filtertitle">Regras</span>
      <div class="filters">
        <span class="description">
          Mínimo Ideal
        </span>
        <button
          type="button"
          @click="openModalConfirm('MinimumRule1')"
          class="cp1-small-button cp1-button__success filterbutton">
          Aplicar
        </button>
      </div>
    </div>

    <modal
      transition="nice-modal-fade"
      name="modalConfirmAddMinimum"
      width="500px"
      height="auto">
      <aside class="modal-confirm">
        <icon-danger class="illustration" />
        <div class="description">
          <p class="info">
            Será aplicado a seguinte regra:
          </p>
          <ul class="ruleexample">
            <li>Custo Total <strong>menor</strong> que R$10.000,00 → Custo + 30%</li>
            <li>Custo Total <strong>maior</strong> que R$10.000,00</li>
            <ul class="ruleexample">
              <li>Item <strong>com</strong> garantia</li>
              <ul class="ruleexample">
                <li>Grupo <strong>medicamento</strong> → custo + 22%</li>
                <li>Grupo <strong>material</strong> → custo + 25%</li>
              </ul>
            </ul>
            <ul class="ruleexample">
              <li>Item <strong>sem</strong> garantia</li>
              <ul class="ruleexample">
                <li>Grupo <strong>medicamento</strong> → custo + 25%</li>
                <li>Grupo <strong>material</strong> → custo + 30%</li>
              </ul>
            </ul>
          </ul>
        </div>


        <section class="cmdcancel">
          <button
            type="button"
            @click="cancelApply"
            class="btn-ghost">Cancelar ação</button>
        </section>
        <form
          @submit.prevent="applyRule"
          class="cmdapply">

          <button-submit
            label="Sim, pode alterar os valores"
            :state="commands.submitState"
            :icon-save="commands.saveIcon" />
        </form>
      </aside>
    </modal>
  </section>
</template>

<script>
import { ButtonSubmit } from '@/components/primitives'
import { IconRightArrow, IconDanger, IconSave } from '@/components/primitives/icons'

export default {
  name: 'ContextMinimumFilter',
  components: {
    ButtonSubmit,
    IconRightArrow,
    IconDanger,
    IconSave
  },
  data: () => ({
    addPercentual: 20,
    ruleToBeAplied: '',
    commands: {
      submitState: 'REPOSE',
      saveIcon: IconSave
    }
  }),
  mounted () {},
  methods: {
    cancelApply () {
      this.$modal.hide('modalConfirmAddMinimum')
    },
    openModalConfirm (rule) {
      this.ruleToBeAplied = rule
      this.$modal.show('modalConfirmAddMinimum')
    },
    async applyRule () {
      try {
        const eventId = this.$route.params.id
        if (!eventId) return false

        await this.$store.dispatch('ItemPricing/MINIMUM_RULE', {
          eventId,
          rule: this.ruleToBeAplied
        })

        await this.$store.dispatch('ItemPricing/LIST_ALL_ITEMS', { eventId })
        this.$toasted.success('Regra aplicada com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível aplicar a regra')
      } finally {
        this.$modal.hide('modalConfirmAddMinimum')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-minimum-filter/ContextMinimumFilter.vue